// ─── Descuentos con autorización (0067) ─────────────────────────────────────
//
// Pedido del piloto: "descuentos con autorización". El negocio decide en
// Configuración → Tu cuenta si un descuento necesita el PIN de alguien con el
// permiso `pos.autorizar_descuentos` (admin por defecto) y desde qué tope:
//   { requiere_autorizacion: bool, tope_pct: 0..100, tope_monto: 0..10.000.000 }
// Topes en 0 = toda rebaja pide autorización; si hay topes, solo la que los
// supere. ESPEJO del trigger `_mezo_descuento_autorizacion` — el servidor es
// la autoridad; esto decide cuándo el POS abre el modal del PIN.

export const DESCUENTOS_DEFAULT = { requiere_autorizacion: false, tope_pct: 0, tope_monto: 0 };

const num = (v) => {
  const n = Number(String(v ?? '').replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export function sanearDescuentosConfig(cfg) {
  if (!cfg || typeof cfg !== 'object') return { ...DESCUENTOS_DEFAULT };
  const tope_pct   = Math.min(100, Math.max(0, Math.round(num(cfg.tope_pct ?? cfg.topePct) * 10) / 10));
  const tope_monto = Math.min(10_000_000, Math.max(0, Math.round(num(cfg.tope_monto ?? cfg.topeMonto))));
  return { requiere_autorizacion: cfg.requiere_autorizacion === true || cfg.requiereAutorizacion === true, tope_pct, tope_monto };
}

// ¿Este descuento (sobre una línea de `bruto` pesos) necesita PIN?
export function descuentoRequiereAutorizacion(cfg, { monto, bruto }) {
  const c = sanearDescuentosConfig(cfg);
  const m = Math.max(0, Math.round(Number(monto) || 0));
  if (!c.requiere_autorizacion || m <= 0) return false;
  const b = Math.max(1, Math.round(Number(bruto) || 0));
  const pct = (m * 100) / b;
  if (c.tope_pct === 0 && c.tope_monto === 0) return true;
  return (c.tope_pct > 0 && pct > c.tope_pct) || (c.tope_monto > 0 && m > c.tope_monto);
}

// Texto para la UI: "cualquier descuento" / "más del 10 %" / "más de $20.000" / ambos.
export function descripcionTope(cfg) {
  const c = sanearDescuentosConfig(cfg);
  const partes = [];
  if (c.tope_pct > 0) partes.push(`más del ${String(c.tope_pct).replace('.', ',')} %`);
  if (c.tope_monto > 0) partes.push(`más de $${c.tope_monto.toLocaleString('es-CO')}`);
  return partes.length ? partes.join(' o ') : 'cualquier descuento';
}
